import { generatePath } from "react-router-dom";
import { ARTICLES, ARTICLES_BY_ID } from "../apiEndPoints";
import { api, convertKeysToCamelCase } from "./api";

export const articleApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllArticles: builder.query({
      query: ({
        accountId,
        offset,
        limit,
        search,
        showAutoEnabled,
        accountTagIds,
        includeTotalCount,
      }) => {
        const baseUrl = generatePath(ARTICLES, { accountId });
        const queryParams = new URLSearchParams({
          offset: String(offset),
          limit: String(limit),
          include_total_count: String(includeTotalCount),
        });
        if (search) {
          queryParams.append("search", search);
        }
        if (accountTagIds?.length) {
          accountTagIds.forEach((id: string) =>
            queryParams.append("account_tag_ids", id)
          );
        }
        if (showAutoEnabled !== null && showAutoEnabled !== undefined) {
          queryParams.append("show_auto_enabled", String(showAutoEnabled));
        }
        return {
          url: `${baseUrl}?${queryParams.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: ["Articles"],
    }),
    getArticle: builder.query({
      query: ({ articleId, accountId }) => ({
        url: generatePath(ARTICLES_BY_ID, { accountId, articleId }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
    }),
  }),
});

export const { useGetAllArticlesQuery, useGetArticleQuery } = articleApiSlice;
